// extracted by mini-css-extract-plugin
module.exports = {"container":"MediaButton_container__dDaHs","title":"MediaButton_title__3h5qX","icon":"MediaButton_icon__31cu3","button":"MediaButton_button__3tg5u"};